var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { Box } from "../box";
import { makeStyles } from "../styles";
import clsx from "../utils/clsx";
import { getCosmosDataProps } from "../utils/comsosCompat";
export var ImageComponentName = "CosmosImage";
export var imageFit = {
    contain: "contain",
    cover: "cover",
    none: "unset",
    "scale-down": "scale-down",
};
export var useImageStyles = makeStyles(function () { return ({
    root: {
        display: "block",
        height: function (props) { return (props.height ? props.height : "auto"); },
        width: function (props) { return (props.width ? props.width : "auto"); },
        maxWidth: function (props) { return (props.disableResponsive ? "auto" : "100%"); },
        objectFit: function (props) { return (props.fit ? imageFit[props.fit] : "unset"); },
    },
}); }, { name: ImageComponentName });
export var Image = React.forwardRef(function (props, ref) {
    var classes = useImageStyles(props);
    var className = props.className, children = props.children, 
    // remove these to prevent passing them along
    fit = props.fit, disableResponsive = props.disableResponsive, rootProps = __rest(props, ["className", "children", "fit", "disableResponsive"]);
    return (React.createElement(Box, __assign({}, { ref: ref }, { className: clsx(classes.root, className) }, rootProps, getCosmosDataProps("image"), { component: "img" }), children));
});
